import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProjectNavigation from "../components/ProjectNavigation";
import ResponsiveImage from "../components/ResponsiveImage";

const CanoeBag = () => {
  // Images for the project
  const finalImages = [
    "/images/projects/Canoe Bag/Final 1",
    "/images/projects/Canoe Bag/Final 2",
    "/images/projects/Canoe Bag/Final 3",
    "/images/projects/Canoe Bag/Final 4"
  ];

  const processImages = [
    "/images/projects/Canoe Bag/Process 1",
    "/images/projects/Canoe Bag/Process 2",
    "/images/projects/Canoe Bag/Process 3",
    "/images/projects/Canoe Bag/Process 4",
    "/images/projects/Canoe Bag/Process 5",
    "/images/projects/Canoe Bag/Process 6",
    "/images/projects/Canoe Bag/Process 7",
    "/images/projects/Canoe Bag/Process 8",
    "/images/projects/Canoe Bag/Process 9",
    "/images/projects/Canoe Bag/Process 10"
  ];

  const renderImages = {
    cattailTuft: [
      "/images/projects/Canoe Bag/Renders/Cattail Tuft Front",
      "/images/projects/Canoe Bag/Renders/Cattail Tuft Back",
      "/images/projects/Canoe Bag/Renders/Cattail Tuft Left",
      "/images/projects/Canoe Bag/Renders/Cattail Tuft Right"
    ],
    northernDeep: [
      "/images/projects/Canoe Bag/Renders/Northern Deep Front",
      "/images/projects/Canoe Bag/Renders/Northern Deep Back",
      "/images/projects/Canoe Bag/Renders/Northern Deep Left",
      "/images/projects/Canoe Bag/Renders/Northern Deep Right"
    ],
    rindline: [
      "/images/projects/Canoe Bag/Renders/Rindline Front",
      "/images/projects/Canoe Bag/Renders/Rindline Back",
      "/images/projects/Canoe Bag/Renders/Rindline Left",
      "/images/projects/Canoe Bag/Renders/Rindline Right"
    ]
  };

  const schematicImages = [
    "/images/projects/Canoe Bag/Schematic Flats/Front Schematic",
    "/images/projects/Canoe Bag/Schematic Flats/Back Schematic",
    "/images/projects/Canoe Bag/Schematic Flats/Left Schematic",
    "/images/projects/Canoe Bag/Schematic Flats/Right Schematic",
    "/images/projects/Canoe Bag/Schematic Flats/Top Schematic",
    "/images/projects/Canoe Bag/Schematic Flats/Bottom Schematic"
  ];

  // Function to create an open in new tab button
  const OpenInNewTabButton = ({ imagePath }) => (
    <a 
      href={`${imagePath}.webp`} 
      target="_blank" 
      rel="noopener noreferrer"
      className="open-in-new-tab-btn"
    >
      Open in new tab
    </a>
  );

  return (
    <div>
      <Header />
      <ProjectNavigation currentProject="/canoe-bag" />
      
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "30px 20px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "40px" }}>Canoe Bag Project</h1>
        
        <p style={{
            maxWidth: "800px",
            margin: "20px auto 40px",
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#333",
            padding: "0 20px",
            textAlign: "center"
        }}>
            A mini canoe shaped bag I created for my prototyping class in which we were tasked with constructing a bag from design to finished product. I 3D printed the bag structure and sewed a cover.
        </p>

        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Final Designs</h2>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 500px), 1fr))", 
            gap: "30px" 
          }}>
            {finalImages.map((img, index) => (
              <div key={`final-${index}`} style={{ 
                position: "relative",
                width: "100%",
                maxWidth: "500px",
                margin: "0 auto"
              }}>
                <ResponsiveImage
                  src={`${img}.webp`}
                  alt={`Final Canoe Bag design ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain"
                  }}
                  priority={index < 2}
                  loading={index < 2 ? "eager" : "lazy"}
                  sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 500px"
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                  <OpenInNewTabButton imagePath={img} />
                </div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Clo3D Renders</h2>
          {Object.entries(renderImages).map(([colorway, images]) => (
            <div key={colorway} style={{ marginBottom: "40px" }}>
              <h3 style={{ 
                marginBottom: "20px",
                textTransform: "capitalize",
                fontSize: "1.5rem"
              }}>
                {colorway.replace(/([A-Z])/g, ' $1').trim()}
              </h3>
              <div style={{ 
                display: "grid", 
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", 
                gap: "20px" 
              }}>
                {images.map((img, index) => (
                  <div key={`${colorway}-${index}`} style={{ position: "relative", aspectRatio: "1/1" }}>
                    <ResponsiveImage
                      src={`${img}.webp`}
                      alt={`${colorway.replace(/([A-Z])/g, ' $1').trim()} view ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      loading="lazy"
                      priority={false}
                      sizes="(max-width: 767px) 100vw, (max-width: 1200px) 33vw, 280px"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                      <OpenInNewTabButton imagePath={img} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>

        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Bag Pattern</h2>
          <div style={{ 
            width: "100%",
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <div style={{
              width: "100%",
              maxWidth: "800px",
              position: "relative"
            }}>
              <ResponsiveImage
                src="/images/projects/Canoe Bag/pattern.webp"
                alt="Pattern Schematic"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block"
                }}
                loading="lazy"
                priority={false}
                sizes="(max-width: 800px) 100vw, 800px"
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <OpenInNewTabButton imagePath="/images/projects/Canoe Bag/pattern" />
              </div>
            </div>
          </div>
        </section>

        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Technical Schematics</h2>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", 
            gap: "25px" 
          }}>
            {schematicImages.map((img, index) => (
              <div key={`schematic-${index}`} style={{ position: "relative", aspectRatio: "1/1" }}>
                <ResponsiveImage
                  src={`${img}.webp`}
                  alt={`Canoe Bag schematic view ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain"
                  }}
                  loading="lazy"
                  priority={false}
                  sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 350px"
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                  <OpenInNewTabButton imagePath={img} />
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 style={{ marginBottom: "30px" }}>Design Process</h2>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", 
            gap: "25px" 
          }}>
            {processImages.map((img, index) => (
              <div key={`process-${index}`} style={{ position: "relative", aspectRatio: "1/1" }}>
                <ResponsiveImage
                  src={`${img}.webp`}
                  alt={`Canoe Bag design process step ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain"
                  }}
                  loading="lazy"
                  priority={false}
                  sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 350px"
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                  <OpenInNewTabButton imagePath={img} />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default CanoeBag;